<script setup lang="ts">
const props = defineProps<{
	row: any,
	cs_id_map: any
}>()

const { copy_w_toast } = useClipboardWithToast()
</script>

<template>
	<div class="text-zinc-800 dark:text-zinc-300">
		<div class="space-y-1">
			<UBadge
				:color="'gray'"
				:label="cs_id_map[row.cs_id?.$oid] ? `**** ${cs_id_map[row.cs_id?.$oid].label}` : '-'"
				variant="solid"
			/>

			<div v-if="cs_id_map[row.cs_id?.$oid]?.ax_data?.bankCardId" class="cursor-pointer rounded-md p-2 bg-gray-100 dark:bg-gray-800" @click="copy_w_toast(cs_id_map[row.cs_id?.$oid].ax_data.bankCardId)">
				SP_CARD_ID: {{ cs_id_map[row.cs_id?.$oid].ax_data.bankCardId }}
			</div>
			<div v-if="cs_id_map[row.cs_id?.$oid]?.ax_user_uid" class="cursor-pointer rounded-md p-2 bg-gray-100 dark:bg-gray-800" @click="copy_w_toast(cs_id_map[row.cs_id?.$oid].ax_user_uid)">
				SP_USER_ID: {{ cs_id_map[row.cs_id?.$oid].ax_user_uid }}
			</div>
		</div>
	</div>
</template>
